export const CURRENT_MEETING = "prevent_meet_09_26";
export const CURRENT_MEETING_TITLE = "Fall PALISI PREVENT";
export const CURRENT_MEETING_LINK =
  "https://teams.microsoft.com/meet/231119960167615?p=Lvw5CwVIh8M99PtlaQ";
export const CURRENT_MEETING_DATE = "9/11/2026 16:15 – 18:15 CST";
export const CURRENT_MEETING_LOCATION =
  "PALISI Meeting (In-Person and Virtual)";

// Old meeting date "Wednesday September 10th, 2025 1:30 PM  3:30 PM Eastern Time (US and Canada)"
